var _filter, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _path, _path2, _circle3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsertImageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pdfGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FF5252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#D32F2F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "imgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4CAF50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2E7D32"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skyGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#81D4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4FC3F7"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow2",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 2,
    floodOpacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 42,
    rx: 4,
    fill: "url(#pdfGrad2)",
    filter: "url(#shadow2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "white",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 16,
    height: 2,
    rx: 1,
    fill: "white",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 18,
    height: 2,
    rx: 1,
    fill: "white",
    opacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 32,
    height: 26,
    rx: 4,
    fill: "url(#skyGrad)",
    filter: "url(#shadow2)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 32,
    height: 26,
    rx: 4,
    fill: "none",
    stroke: "url(#imgGrad)",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 34,
    r: 5,
    fill: "#FFD54F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 34,
    r: 7,
    fill: "#FFD54F",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 52 L34 38 L40 44 L50 32 L58 52 Z",
    fill: "#66BB6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52 L38 40 L46 48 L58 52 Z",
    fill: "#43A047"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 18,
    r: 10,
    fill: "#FF9800",
    filter: "url(#shadow2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 12 V24 M48 18 H60",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertImageIcon);
export default __webpack_public_path__ + "static/media/insert-image-icon.35a10b6b67b40b5895afee950f3cd606.svg";
export { ForwardRef as ReactComponent };